import { render, staticRenderFns } from "./EditGatewaysModal.vue?vue&type=template&id=964ceeac&scoped=true&"
import script from "./EditGatewaysModal.vue?vue&type=script&lang=ts&"
export * from "./EditGatewaysModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditGatewaysModal.vue?vue&type=style&index=0&id=964ceeac&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964ceeac",
  null
  
)

export default component.exports